var _path, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMutedVideocamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 7.91667L15.4793 6.11452C16.0057 5.85133 16.625 6.2341 16.625 6.82261V12.1774C16.625 12.7659 16.0057 13.1487 15.4793 12.8855L11.875 11.0833M3.95833 14.25H10.2917C11.1661 14.25 11.875 13.5411 11.875 12.6667V6.33333C11.875 5.45888 11.1661 4.75 10.2917 4.75H3.95833C3.08388 4.75 2.375 5.45888 2.375 6.33333V12.6667C2.375 13.5411 3.08388 14.25 3.95833 14.25Z",
    stroke: "#9CA3AF",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.791504,
    y1: 15.6351,
    x2: 13.2599,
    y2: 3.16667,
    stroke: "#9CA3AF",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMutedVideocamera);
export default __webpack_public_path__ + "static/media/mutedVideocamera.1d9ae3f8a8758179f8aaa3e0afdc02f0.svg";
export { ForwardRef as ReactComponent };